import { render, staticRenderFns } from "./right-suspension.vue?vue&type=template&id=7113fec4&scoped=true"
import script from "./right-suspension.vue?vue&type=script&lang=js"
export * from "./right-suspension.vue?vue&type=script&lang=js"
import style0 from "./right-suspension.vue?vue&type=style&index=0&id=7113fec4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7113fec4",
  null
  
)

export default component.exports